/**
 * @internal
 */
import React, { createContext, useContext } from 'react';
export const ConfigContext = createContext({});
const ConfigProvider = ({ config = {}, children, }) => {
    return React.createElement(ConfigContext.Provider, { value: { ...config } }, children);
};
export default ConfigProvider;
export const useConfig = (key, defaultValue = null) => {
    var _a;
    const context = useContext(ConfigContext);
    return key ? ((_a = context[key]) !== null && _a !== void 0 ? _a : defaultValue) : context;
};
